import { costosApi, cuentasCobroApi } from "../../services/api";
import { cuentaCobroTutor } from "../../objetos/objeto_cuentas_Cobro";
import { useLoading } from "../../utils/LoadingProvider";
import React, { useState, useMemo, useCallback } from 'react';
import { toast } from 'react-toastify';
import { getSocket } from '../../services/socket';
import { conversionFechaJson, convertirFechaFirebase } from "../../objetos/utiles_objetos";
import { toYYYYMMDD } from "../../utils/utils";

export const useCuentaCobroModel = () =>{
    const [cuentasDeCobro, setcuentaCobro] = useState([]);
    const [loadingcuentaCobro, setLoading] = useState(true);
    const [errorcuentaCobro, setError] = useState(null);

    //id y fecha
    const [idPago, setIdPago] = useState();
    const [ultimoFechaPago, setultimoFechaPago] = useState();

    const { withLoading } = useLoading();

    //empresas a cobrar
    const [empresasACobrar, setempresasACobrar] = useState([]);
    const [loadingempresasACobrar, setLoadingempresasACobrar] = useState(true);
    const [errorempresasACobrar, setErrorempresasACobrar] = useState(null);

    //add cuenta cobro
    const addCuentaCobro = async(nombreEmpresa, cuentaCobroData) =>{
        return await withLoading(async () =>{
            try{
                console.log("añadiendo nueva cuenta de cobro",nombreEmpresa,cuentaCobroData);

                const cuentacobroInstance = new cuentaCobroTutor(cuentaCobroData);
                const cuentacobroMap = cuentacobroInstance.toMap();

                console.log("cuuenta cobro map",cuentacobroMap);

                const respuesta = await cuentasCobroApi.addCuentaCobro(nombreEmpresa, cuentacobroMap,cuentaCobroData);
                
                if(respuesta.success){
                    toast.success(respuesta.message);
                }else{
                    toast.error(respuesta.message);
                }
                
            }
            catch(error){
                console.error('Error interno:', error);
                throw error;
            }
        }, 'Añadiendo cuenta de cobro');
    }

    //update cuenta de cobro
    const updateCuentaCobro = async(idDocumento,nombreEmpresa,field,valor,type = 'field',archivo) =>{
        return withLoading(async () =>{
            let finalUpdateData = {};

            if(!field ){
                toast.error("Este error no deberia salir");
                return;
            }

            if(type == "field" ){
                const datosParaValidar = { [field]: valor };
                const cuentacobroTemporal = new cuentaCobroTutor({});
                cuentacobroTemporal.updateFromJson(datosParaValidar);
            
                const valorConvertido = cuentacobroTemporal.getFieldValue(field);
            
                finalUpdateData = {
                    [field]: valorConvertido
                 };
            }
            else if(type == "array"){
                           
            }

            try{

                const respuesta = await cuentasCobroApi.updateCuentaCobro(idDocumento,nombreEmpresa,finalUpdateData,type,archivo);
                
                if (respuesta.success) {
                    toast.success(`Exito: ${respuesta.message}`);
                } else {
                    toast.error(`Error: ${respuesta.message}`);
                }

            }
            catch(error){
                console.error('Error al actualizar la cuenta de cobro', error);
                toast.error("Ocurrió un error a actualizar la cuenta de cobro: " + (error.message || "Error desconocido"));
                return { success: false, error: error };
            }
        },'Actualizando cuenta de cobro');
    }

    //cargar cuentas de cobro de administarador
    const cargarCuentasCobros = async(nombreEmpresa) =>{
        console.log("a cargar cuentas de cobro");
        try{
            setLoading(true);
            setError(null);

            const response = await cuentasCobroApi.getCuentasCobro(nombreEmpresa);
            const data = response.data;
            const dataConvertida = Object.values(data);
            const cuentacobro_obj = dataConvertida.map(cuentaCobrodata => cuentaCobroTutor.fromJson(cuentaCobrodata));
            setcuentaCobro(cuentacobro_obj);
        }
        catch(error){
            setError('Error al cargar las cuentas de cobro: ' + error.message);
        }
        finally{
            setLoading(false);
        }
    }

    //estadocuentaCobro, de pago
    const getPagosReferenciasCuentaCobro = useCallback(async (fechaReferencia,nombreEmpresa, referencia, nameTutor) => {
        try {
        // (He corregido la lógica que me enviaste antes)
        const fecha = new Date(fechaReferencia.getFullYear(),fechaReferencia.getMonth(),fechaReferencia.getDate());
        const fechaConverted = toYYYYMMDD(fecha);

        const respuesta = await cuentasCobroApi.getPagosReferenciasAsociadas(fechaConverted,nombreEmpresa, referencia, nameTutor);
        if (respuesta && respuesta.success) {
            return respuesta.data.data;
        }
        
        return null;
        } catch (error) {
        console.error('Error interno:', error);
        return null;
        }
    }, []);

    //obtener cuentas de cobro de tutor
    const getCuentaCobroTutor = async(nombreEmpresa,nombreTutor) =>{
        try{
            setLoading(true);
            setError(null);

            const response = await cuentasCobroApi.getCuentasCobroTutor(nombreEmpresa,nombreTutor);
            const datalistaCuentas = response.data.listaCuentas;
            const dataProximoPago = response.data.nextIdPago;
            const dataUltimaFechaCobro = convertirFechaFirebase(response.data.ultimaFechaCobro);

            const dataConvertida = Object.values(datalistaCuentas);
            
            const cuentacobro_obj = dataConvertida.map(cuentaCobrodata => cuentaCobroTutor.fromJson(cuentaCobrodata));
            setcuentaCobro(cuentacobro_obj);
            setIdPago(dataProximoPago);
            setultimoFechaPago(dataUltimaFechaCobro);
        }
        catch(error){
            setError('Error al cargar las cuentas de cobro del tutor: ' + error.message);
        }
        finally{
            setLoading(false);
        }
    }

    //webhook
    const setupWebSocketsCuentasCobro = (nombreEmpresaActual) =>{
        const socket = getSocket();

        const handlecuentasCobroUpdate = ({data, type, nombreEmpresa}) =>{
            console.log(`Evento WebSocket 'modified' recibido. ${type} ${nombreEmpresa}`);

            if (nombreEmpresa !== nombreEmpresaActual) {
                return;
            }

            setcuentaCobro(prevcuentaCobro => {
                const cuentaCobroRecibido = cuentaCobroTutor.fromJson(data);

                const idDocumentoRecibido = cuentaCobroRecibido.idDocumento;

                const indiceExistente = prevcuentaCobro.findIndex(c => c.idDocumento === idDocumentoRecibido);

                if (indiceExistente === -1) {
                    return [cuentaCobroRecibido, ...prevcuentaCobro];
                }

                const cuentaCobrosActualizados = [...prevcuentaCobro];
                cuentaCobrosActualizados[indiceExistente] = cuentaCobroRecibido;

                return cuentaCobrosActualizados;


            });
        }

        socket.on('cuentasCobro:update',handlecuentasCobroUpdate);

        return () => {
            console.log("Desuscribiendo del evento costos:update");
            socket.off('cuentasCobro:update', handlecuentasCobroUpdate);
        };

    }

    //obtener empresas para cobrar
    const getEmpresasCobro = async (nombreTutor) =>{
        try{
            setLoadingempresasACobrar(true);
            setErrorempresasACobrar(null);

            const response = await cuentasCobroApi.getEmpresasCobro(nombreTutor);
            console.log("el response de empresass es",response);
            setempresasACobrar(response);
        }
        catch(error){
            setError('Error al cargar empresas para cobro: ' + error.message);
        }
        finally{
            setLoadingempresasACobrar(false);
        }
    }

    return{
        cuentasDeCobro,
        loadingcuentaCobro,
        errorcuentaCobro,

        addCuentaCobro,
        updateCuentaCobro,
        cargarCuentasCobros,

        getCuentaCobroTutor, //obtener cuentas de cobro de tutor
        idPago,
        ultimoFechaPago,

        //pagos asociados a referencias
        getPagosReferenciasCuentaCobro,
        getEmpresasCobro,
        empresasACobrar,
        loadingempresasACobrar,
        errorempresasACobrar,

        //webhook
        setupWebSocketsCuentasCobro,
    };

}